import { gql, TypedDocumentNode } from "@apollo/client";
import {
  GetSharedFilesQueryVariables,
  GetSharedFilesQuery,
  CreateSharedFileMutation,
  CreateSharedFileMutationVariables,
  DeleteSharedFileMutation,
  DeleteSharedFileMutationVariables,
} from "generated/graphql";

// QUERIES

export const SHARED_FILES_QUERY: TypedDocumentNode<
  GetSharedFilesQuery,
  GetSharedFilesQueryVariables
> = gql`
  query GetSharedFiles {
    sharedFiles {
      id: token
      downloadCount
      expiresAt
      path
      tbfLink
      token
      externalLink
      insertedAt
      isOneTime
    }
  }
`;

// MUTATIONS

export const CREATE_SHARED_FILE_MUTATION: TypedDocumentNode<
  CreateSharedFileMutation,
  CreateSharedFileMutationVariables
> = gql`
  mutation CreateSharedFile(
    $path: String!
    $expiresAt: DateTime
    $isOneTime: Boolean
  ) {
    createSharedFile(
      expiresAt: $expiresAt
      path: $path
      isOneTime: $isOneTime
    ) {
      id: token
      token
      downloadCount
      expiresAt
      tbfLink
      path
      externalLink
      insertedAt
    }
  }
`;

export const DELETE_SHARED_FILE_MUTATION: TypedDocumentNode<
  DeleteSharedFileMutation,
  DeleteSharedFileMutationVariables
> = gql`
  mutation DeleteSharedFile($token: String!) {
    deleteSharedFile(token: $token) {
      id: token
    }
  }
`;
